import * as React from 'react';
import { Industry } from 'components/context/types';
import { TreeSelect } from 'antd';
import t from 'utils/translations';
import { TreeNode } from 'antd/es/tree-select';
import { useState } from 'react';
import { useEffect } from 'react';

function convertIndustriesToTreeNodes(industryTree: Industry[]): TreeNode[] {
    return industryTree.map((industry: Industry) => {
        return {
            // NOTE: value needs to have also the label, so that search works in the TreeSelect
            value: `${industry.value}|${industry.label}`,
            title: industry.label,
            key: industry.value,
            children: convertIndustriesToTreeNodes(industry.children)
        };
    });
}

interface Props {
    industryTree: Industry[];
    onSelect: (value: string) => void;
    value?: string;
}

function IndustryTreeSelector({ industryTree, onSelect, value }: Props) {
    const [treeData, setTreeData] = useState<TreeNode[]>([] as TreeNode[]);

    useEffect(() => {
        const data: TreeNode[] = convertIndustriesToTreeNodes(industryTree);
        setTreeData(data);
    }, [industryTree]);

    return (
        <TreeSelect
            treeData={treeData}
            onSelect={onSelect}
            placeholder={t('CHOOSE_INDUSTRY')}
            showSearch={true}
            value={value}
        />
    );
}

export default IndustryTreeSelector;
